// SavedInvestigations
export const selectSavedInvestigationSearchResults = (state) =>
  state.savedInvestigations.totalRows;
export const selectLoadedSavedInvestigations = (state) =>
  state.savedInvestigations.loadedResults;
export const selectResetSavedInvestigations = (state) =>
  state.savedInvestigations.reset;
export const selectInvestigations = (state) =>
  state.savedInvestigations.loadedResults;
export const selectInvestigationTotalRows = (state) =>
  state.savedInvestigations.totalRows;
export const selectInvestigationsLoading = (state) =>
  state.savedInvestigations.loading;
export const selectSavedInvestigationsSearchText = (state) =>
  state.savedInvestigations.searchText;
export const selectSavedInvestigationsZeroResults = (state) =>
  state.savedInvestigations.hasZeroResults;
